import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { apiFetch } from "../utils/api";
import { BadgeFormaPago, sumarPorMoneda, textoPorMoneda } from "../utils/estados";
import {
  BadgeCredito,
  FASES_CREDITO,
  colorAvatar,
  fechaCorta,
  folioPago,
  montoTextoPago,
  textoPlazo,
} from "../utils/pagosUi";
import { Ayuda } from "../context/AyudaContext";
import Cargando from "../components/Cargando";

// Facturas a crédito por pagar. El crédito no frena la compra: el plazo (30
// días) empieza a contar cuando se recibe el producto con su factura, y aquí
// Pagos controla que se salde a tiempo.
function Creditos() {
  const navigate = useNavigate();
  const usuario = JSON.parse(localStorage.getItem("usuario") || "null");
  const puedePagar = usuario?.rol === "pagos" || usuario?.rol === "administrador";

  const [creditos, setCreditos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [filtroFase, setFiltroFase] = useState("");
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    apiFetch("/api/pagos/creditos")
      .then((data) => setCreditos(data || []))
      .catch((err) => setError(err.message))
      .finally(() => setCargando(false));
  }, []);

  const resumen = Object.keys(FASES_CREDITO).map((fase) => {
    const delaFase = creditos.filter((c) => c.fase_credito === fase);
    return { fase, cantidad: delaFase.length, monto: sumarPorMoneda(delaFase.map((c) => ({ moneda: c.moneda, monto: c.monto_total }))) };
  });

  const termino = busqueda.trim().toLowerCase().replace("#", "");
  const visibles = creditos.filter((c) => {
    if (filtroFase && c.fase_credito !== filtroFase) return false;
    if (
      termino &&
      !c.proveedor_nombre.toLowerCase().includes(termino) &&
      !c.solicitante_nombre.toLowerCase().includes(termino) &&
      !String(c.solicitud_id).padStart(3, "0").includes(termino)
    ) {
      return false;
    }
    return true;
  });

  return (
    <div>
      <Link to="/pagos" style={styles.volver}>
        ← Regresar a Pagos
      </Link>
      <h2 style={{ margin: "0.4rem 0 0", color: "var(--tema-titulo, #0b3c60)", textAlign: "center" }}>🗓️ Facturas a crédito</h2>
      <Ayuda>
        <p style={{ color: "#5b6472", marginTop: "0.25rem", textAlign: "center" }}>
          Compras a crédito aprobadas. No frenan la compra: el plazo de 30 días empieza cuando se recibe el
          producto con su factura. Aquí se controla que se paguen a tiempo.
        </p>
      </Ayuda>

      <div className="tarjetas-resumen" style={styles.tarjetas}>
        {resumen.map((r) => {
          const f = FASES_CREDITO[r.fase];
          const activa = filtroFase === r.fase;
          return (
            <button
              key={r.fase}
              type="button"
              onClick={() => setFiltroFase(activa ? "" : r.fase)}
              style={{ ...styles.tarjeta, ...(activa ? { borderColor: f.color, boxShadow: `0 0 0 2px ${f.bg}` } : {}) }}
            >
              <span style={{ ...styles.tarjetaIcono, color: f.color, background: f.bg }}>{f.icono}</span>
              <span style={{ textAlign: "left" }}>
                <span style={styles.tarjetaTitulo}>{f.texto}</span>
                <span style={styles.tarjetaValor}>{r.cantidad}</span>
                <span style={styles.tarjetaMonto}>{textoPorMoneda(r.monto)}</span>
              </span>
            </button>
          );
        })}
      </div>

      <div style={styles.card}>
        <div className="barra-filtros" style={styles.filtros}>
          <input
            type="text"
            placeholder="Buscar solicitud, proveedor o solicitante..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            style={{ ...styles.input, flex: 1, minWidth: 220 }}
          />
          {(busqueda || filtroFase) && (
            <button
              type="button"
              onClick={() => {
                setBusqueda("");
                setFiltroFase("");
              }}
              style={styles.botonSecundario}
            >
              🧹 Limpiar
            </button>
          )}
        </div>

        {error && <p style={{ color: "#a3402f" }}>{error}</p>}

        {cargando ? (
          <Cargando compacto />
        ) : visibles.length === 0 ? (
          <p style={{ color: "#5b6472", textAlign: "center", padding: "1.5rem 0" }}>
            {creditos.length === 0
              ? "Todavía no hay facturas a crédito. Aparecen cuando el gerente aprueba una compra a crédito."
              : "No hay facturas con ese filtro."}
          </p>
        ) : (
          <div className="table-scroll" style={styles.tablaWrap}>
            <table style={styles.tabla}>
              <thead>
                <tr style={{ textAlign: "center", borderBottom: "1px solid #d3d9df" }}>
                  <th style={styles.thAcento}></th>
                  <th style={styles.th}>Solicitud</th>
                  <th style={styles.th}>Proveedor</th>
                  <th style={styles.th}>Solicitante</th>
                  <th style={styles.th}>Fecha</th>
                  <th style={{ ...styles.th, textAlign: "right" }}>Monto aprobado</th>
                  <th style={styles.th}>Forma de pago</th>
                  <th style={styles.th}>Vence</th>
                  <th style={styles.th}>Estado</th>
                  <th style={styles.th}>Aprobado por</th>
                  <th style={styles.th}>Acción</th>
                </tr>
              </thead>
              <tbody>
                {visibles.map((c, i) => (
                  <tr
                    key={c.id}
                    style={{ borderBottom: "1px solid #eef1f3", background: i % 2 === 1 ? "#fafbfc" : "transparent" }}
                  >
                    <td style={{ ...styles.tdAcento, background: FASES_CREDITO[c.fase_credito]?.color || "#d3d9df" }}></td>
                    <td style={styles.td}>
                      <Link to={`/solicitud/${c.solicitud_id}`} style={styles.linkFolio}>
                        {folioPago(c.solicitud_id)}
                      </Link>
                    </td>
                    <td style={styles.td}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <span style={{ ...styles.avatar, background: colorAvatar(c.proveedor_nombre) }}>
                          {c.proveedor_nombre.charAt(0).toUpperCase()}
                        </span>
                        <span style={{ fontWeight: 600, color: "var(--tema-titulo, #0b3c60)" }}>{c.proveedor_nombre}</span>
                      </div>
                    </td>
                    <td style={styles.td}>
                      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                        <span style={{ ...styles.avatar, background: colorAvatar(c.solicitante_nombre) }}>
                          {c.solicitante_nombre.charAt(0).toUpperCase()}
                        </span>
                        <div>
                          {c.solicitante_nombre}
                          <div style={styles.sub}>{c.area_nombre}</div>
                        </div>
                      </div>
                    </td>
                    <td style={{ ...styles.td, whiteSpace: "nowrap" }}>
                      {c.creado_en
                        ? new Date(c.creado_en).toLocaleDateString("es-NI", { day: "2-digit", month: "2-digit", year: "numeric" })
                        : "—"}
                    </td>
                    <td
                      style={{
                        ...styles.td,
                        textAlign: "right",
                        fontWeight: 700,
                        whiteSpace: "nowrap",
                        fontVariantNumeric: "tabular-nums",
                      }}
                    >
                      {montoTextoPago(c)}
                    </td>
                    <td style={styles.td}>
                      <BadgeFormaPago valor="credito" />
                    </td>
                    <td style={styles.td}>
                      {c.fase_credito === "pagado" ? (
                        <>
                          Pagado el {fechaCorta(c.fecha_pago)}
                          <div style={styles.sub}>Vencía {fechaCorta(c.vence_en)}</div>
                        </>
                      ) : c.vence_en ? (
                        <>
                          {fechaCorta(c.vence_en)}
                          <div
                            style={{
                              ...styles.sub,
                              ...(c.fase_credito === "vencido" ? { color: "#a3402f", fontWeight: 700 } : {}),
                            }}
                          >
                            {textoPlazo(c)}
                          </div>
                        </>
                      ) : (
                        <span style={styles.sub}>{textoPlazo(c)}</span>
                      )}
                    </td>
                    <td style={styles.td}>
                      <BadgeCredito fase={c.fase_credito} />
                    </td>
                    <td style={styles.td}>{c.aprobado_por_nombre || "—"}</td>
                    <td style={styles.td}>
                      <button
                        type="button"
                        onClick={() => navigate(`/pagos/creditos/${c.id}`)}
                        style={c.fase_credito !== "pagado" && puedePagar ? styles.botonPagar : styles.botonSecundario}
                      >
                        Ver detalle
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  volver: { color: "var(--tema-titulo, #0b3c60)", fontWeight: 600, fontSize: "0.88rem", textDecoration: "none" },
  tarjetas: { display: "flex", flexWrap: "wrap", gap: "0.8rem", marginTop: "1.1rem" },
  tarjeta: {
    flex: "1 1 190px",
    display: "flex",
    alignItems: "center",
    gap: "0.8rem",
    border: "1px solid #e2e6ea",
    borderRadius: 12,
    padding: "0.85rem 1rem",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
    cursor: "pointer",
    fontFamily: "inherit",
  },
  tarjetaIcono: {
    width: 42,
    height: 42,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.2rem",
    fontWeight: 700,
    flexShrink: 0,
  },
  tarjetaTitulo: { display: "block", fontSize: "0.74rem", fontWeight: 700, color: "#5b6472", textTransform: "uppercase", letterSpacing: "0.03em" },
  tarjetaValor: { display: "block", fontSize: "1.5rem", fontWeight: 800, color: "var(--tema-titulo, #0b3c60)", lineHeight: 1.15 },
  tarjetaMonto: { display: "block", fontSize: "0.76rem", color: "#8993a1", fontVariantNumeric: "tabular-nums" },
  card: {
    border: "1px solid #e2e6ea",
    borderRadius: 14,
    padding: "1.25rem 1.4rem",
    marginTop: "1.1rem",
    background: "#fff",
    boxShadow: "0 1px 3px rgba(27,42,74,0.06)",
  },
  filtros: { display: "flex", gap: "0.6rem", flexWrap: "wrap", alignItems: "center", marginBottom: "1rem" },
  input: { padding: "0.45rem 0.6rem", border: "1px solid #d3d9df", borderRadius: 6, fontFamily: "inherit", fontSize: "0.85rem", boxSizing: "border-box" },
  tablaWrap: { border: "1px solid #eef1f3", borderRadius: 10 },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: "0.88rem" },
  th: { padding: "0.55rem 0.5rem", background: "#eef1f3", border: "1px solid #d3d9df", fontSize: "0.76rem", color: "var(--tema-titulo, #0b3c60)", whiteSpace: "nowrap" },
  td: { padding: "0.65rem 0.7rem", textAlign: "left", verticalAlign: "middle", borderLeft: "1px solid #e3e8ee", borderRight: "1px solid #e3e8ee" },
  thAcento: { padding: 0, width: 4, background: "#eef1f3", border: "none", borderBottom: "1px solid #d3d9df" },
  tdAcento: { padding: 0, width: 4 },
  avatar: { width: 26, height: 26, borderRadius: "50%", color: "#fff", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "0.68rem", fontWeight: 700, flexShrink: 0 },
  sub: { fontSize: "0.75rem", color: "#8993a1", marginTop: "0.1rem" },
  linkFolio: { color: "var(--tema-primario, #2f6690)", fontWeight: 700, textDecoration: "none" },
  itemPago: { display: "flex", alignItems: "baseline", gap: "0.5rem", marginTop: "0.3rem", fontSize: "0.86rem", color: "var(--tema-titulo, #0b3c60)", fontWeight: 600 },
  chipItem: { fontSize: "0.68rem", fontWeight: 700, color: "#0f7c8a", background: "#d5eef1", borderRadius: 999, padding: "0.1rem 0.5rem", whiteSpace: "nowrap", flexShrink: 0 },
  cantidad: { fontWeight: 400, color: "#5b6472", fontSize: "0.8rem" },
  masProductos: { marginTop: "0.3rem", fontSize: "0.76rem", fontWeight: 700, color: "var(--tema-primario, #2f6690)" },
  botonPagar: { background: "#0f7c8a", color: "#fff", border: "none", borderRadius: 8, padding: "0.5rem 0.9rem", fontSize: "0.82rem", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" },
  botonSecundario: { background: "#fff", color: "var(--tema-titulo, #0b3c60)", border: "1px solid #d3d9df", borderRadius: 8, padding: "0.5rem 0.9rem", fontSize: "0.82rem", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap" },
};

export default Creditos;
